import { DocumentNode, gql } from '@apollo/client';
import { HStack, StackProps, Tag, Text, VStack } from '@chakra-ui/react';
import * as React from 'react';

import { ECommunityVisibility } from '@/graphql-types/globalTypes';

import { GroupListItemContent_GroupFragment } from './graphql-types/GroupListItemContent_GroupFragment';

import { ProfileImageIcon } from '../../ProfileImageIcon';

export const Content: React.FC<
  {
    group: GroupListItemContent_GroupFragment;
    showHiddenTag: boolean;
    truncateName?: boolean;
    iconSize?: number;
  } & StackProps
> & {
  groupFragment: DocumentNode;
} = ({ showHiddenTag, group, truncateName, iconSize, ...stackProps }) => {
  return (
    <HStack spacing="4" {...stackProps}>
      <ProfileImageIcon
        group={group}
        flexShrink="0"
        {...(iconSize ? { h: iconSize, w: iconSize } : {})}
      />
      <VStack alignItems="start" w="full" spacing="0">
        <HStack>
          <Text
            textStyle="bodyStrong"
            noOfLines={!!truncateName ? 1 : undefined}
            textAlign="start"
          >
            {group.name}
          </Text>
          {showHiddenTag &&
            group.settings.communityVisibility ===
              ECommunityVisibility.HIDDEN && (
              <Tag variant="solid" colorScheme="gray">
                Hidden
              </Tag>
            )}
        </HStack>
        <Text color="gray.600" textStyle="compact">
          {group.totalMembers === 1
            ? '1 Member'
            : `${group.totalMembers} Members`}
        </Text>
      </VStack>
    </HStack>
  );
};
Content.groupFragment = gql`
  fragment GroupListItemContent_GroupFragment on Group {
    _id
    name
    totalMembers
    priority
    settings {
      communityVisibility
    }
    currentUserGroupLink {
      _id
    }
    ...ProfileImageIcon_GroupFragment
  }
  ${ProfileImageIcon.groupFragment}
`;
